class NavOverlayRoot extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.railButtons = [...this.querySelectorAll(".nav-overlay__rail-btn[data-panel]")];
    this.panels = [...this.querySelectorAll(".nav-overlay__panel")];

    document.querySelectorAll("[data-nav-overlay-open]").forEach((btn) => {
      btn.addEventListener("click", () => this.open());
    });

    this.querySelector(".nav-overlay__close").addEventListener("click", () => this.close());
    this.querySelector(".nav-overlay__back").addEventListener("click", () => {
      this.dialog.classList.remove("is-drilled");
    });

    this.dialog.addEventListener("click", (e) => {
      if (e.target === this.dialog) this.close();
    });
    this.dialog.addEventListener("cancel", (e) => {
      e.preventDefault();
      this.close();
    });

    for (const btn of this.railButtons) {
      btn.addEventListener("click", () => {
        this.activate(btn, { drill: true });
        // first switch done → panels swap instantly from here on (see CSS)
        this.dialog.classList.add("has-switched");
      });
    }
  }

  open() {
    this.dialog.classList.remove("is-closing", "is-drilled", "has-switched");
    this.dialog.showModal();
    if (this.railButtons.length) {
      this.activate(this.#contextButton() || this.railButtons[0]);
    }
  }

  // pick the rail group matching the page currently being viewed
  #contextButton() {
    const path = location.pathname;
    return (
      this.railButtons.find((b) => b.dataset.url === path) ||
      this.railButtons.find((b) => (b.dataset.subUrls || "").split(" ").includes(path)) ||
      this.railButtons.find((b) => path.startsWith(b.dataset.url + "/")) ||
      null
    );
  }

  close() {
    this.dialog.classList.add("is-closing");
    const done = () => {
      this.dialog.classList.remove("is-closing");
      this.dialog.close();
    };
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) done();
    else this.dialog.addEventListener("animationend", done, { once: true });
  }

  activate(btn, { drill = false } = {}) {
    for (const b of this.railButtons) {
      const active = b === btn;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-expanded", String(active));
    }
    for (const panel of this.panels) {
      panel.hidden = panel.id !== btn.dataset.panel;
    }
    if (drill) this.dialog.classList.add("is-drilled");
  }
}

if (!customElements.get("nav-overlay-root")) {
  customElements.define("nav-overlay-root", NavOverlayRoot);
}
